import styled from 'styled-components';
import { breakpoints, colors, fontFamily, densityOptions, zIndex } from '../../ui/variables';

export const NiftiAnnotationToolStyle = styled.div`
    .web-visualizer-modal-container {
        position: absolute;
        background-color: ${colors.black};
        height: 100%;
        padding: 50px 0 0;
        width: 100%;
    }

    .web-visualizer-container {
        position: absolute;
        background-color: ${colors.black};
        height: 100%;
        padding: 48px 0 0;
        width: 100%;
    }

    .confirm-undo-modal-container {
      position: fixed; /* Garante que o modal fique sobreposto */
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1050; /* Deve ser maior que o modal externo */
      padding: 24px 48px 44px 40px;
      background-color: #F9FAFF;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

      .undo-modal-title,
      .undo-modal-question,
      .undo-modal-description,
      .undo-modal-actions {
        max-width: 404px;
      }

      .undo-modal-title {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.veryDarkGray};
        font-size: 18px;
        line-height: 22px;
        margin-bottom: 12px;
      }

      .undo-modal-question {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.veryDarkGray};
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 12px;
      }

      .undo-modal-description {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.veryDarkGray};
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 20px;
      }

      .undo-modal-actions {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;

        .modal-action-wrapper {
          flex-basis: calc(50% - 16px);

          &:first-child {
            margin-right: 32px;
          }
        }
      }
    }
    .undo-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Fundo semitransparente */
    z-index: 1049; /* Um nível abaixo do modal interno */
  }
`

export const CanvasWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-areas:
    'inputs inputs'
    'previews previews';
  grid-template-rows: auto 1fr;
  grid-template-columns: 1fr 1fr;
  background-color: black;

  @media (max-width: ${breakpoints.wxgaPlus.width}px) {
    overflow-y: auto; !important;
  }

  justify-content: flex-start;
  position: relative;
  .horizontal-guide,
        .vertical-guide {
          background-color: ${colors.white};
          position: absolute;
        }

        .horizontal-guide {
          height: 1px;
          left: 0;
          width: 100%;
        }

        .vertical-guide {
          height: 100%;
          top: 0;
          width: 1px;
        }

        .center-guide {
          border: solid 1px ${colors.white};
          border-radius: 50%;
          height: 20px;
          position: absolute;
          width: 20px;
        }
`;

export const InputsWrapper = styled.div`
  grid-area: inputs;
  background-color: rgb(68, 77, 90);
  padding: 8px 24px;
  display: grid;
  grid-template-rows: auto auto;
  row-gap: 8px;
  z-index: 9;

  .inputs-row--top {
  display: grid;
  grid-template-columns: 145px 315px 355px 315px 1fr 150px 1fr;
  gap: 15px;
  align-items: center;
}

@media (max-width: ${breakpoints.wxgaPlus.width}px) {
  .inputs-row--top {
    display: grid;
    gap: 15px;
    align-items: center;
    grid-template-columns: 1fr 315px 145px auto;
    grid-auto-rows: auto;
    row-gap: 12px;
  }
}

.inputs-row--bottom {
  display: grid;
  grid-template-columns: 145px 157px 140px 355px 315px 2fr;
  gap: 15px;
  align-items: flex-start;
}

  @media (max-width: ${breakpoints.wxgaPlus.width}px) {
    .inputs-row--bottom {
      display: grid;
      grid-template-columns:
      145px 145px 145px 1fr 315px 2fr;
      gap: 20px;
      align-items: center;
    }
  }

.tool {
  display: flex;
}

.tool--dimension {
  height: 100%;
}

.tool--undo {
  height: 100%;
}

.tool--actions {
  justify-content: flex-end;
  gap: 8px;
}

.tool--window {
  gap: 4px;
}

.tool--buttons-group {
  display: grid;
  grid-template-columns: 110px 110px 1fr;
  gap: 15px;
  align-items: center;
  width: 100%;
}

.tool--diameter {
  width: 100%;
}

.tool--opacity {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}

.tool--sliders-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
}

.tool--voxel {
  font-family: SourceSansPro;
  font-weight: bold;
  font-style: normal;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 8px;
  display: flex;
  font-size: 14px;
  height: 48px;
  line-height: 14px;
  padding: 8px 16px;
  background-color: #303A48;
  border: solid 1px #303A48;
  color: #F9FAFF;
}

  .slider-track{
    width: 100%;
    height: 5px;
    background-color: ${colors.softBlue};
    margin: auto;
    top: 0;
    bottom: 0;
    border-radius: 5px;
  }

  .density-limits-label,
  .density-limits-value {
    ${fontFamily.sourceSansPro.regular};
    color: ${colors.veryPaleBlue};
    line-height: 20px;
    padding: 0;
    text-align: center;
  }


.density-limits-slider {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
}

  .density-limits-label {
    padding-right: 12px;
  }

  .density-limits-value {
    padding: 4px;
  }
  
  
  .density-limits-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .slider-wrapper {
  position: relative;
}

  .slider-tooltip {
  position: absolute;
  transform: translateX(-50%);
  background-color: ${colors.softBlue}; 
  color: white;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;

}

  .tool-label {
    ${fontFamily.sourceSansPro.regular}
    color: ${colors.veryPaleBlue};
    font-size: 14px;
    line-height: 22px;

    &.tool-label-bold {
      ${fontFamily.sourceSansPro.bold}
    }
  }
  
  .color-selector{
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid rgb(0, 0, 0);
    background-color: rgb(170, 170, 170);
  }

  .density-limits-selector {
    padding-right: 32px;
    position: relative;
    
    &:after {
      background-color: ${colors.softBlue};
      content: '';
      display: block;
      height: 32px;
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
    }

  }

  
  .color-annotation-selector {
    padding-right: 32px;
    position: relative;
  
    &:after {
      background-color: ${colors.softBlue};
      content: '';
      display: block;
      height: 32px;
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
    }
  }


  .tools-list-row {
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;

    &.main-tools-row {
      flex-basis: 100%;
      margin-bottom: 16px;

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        flex-basis: 70%;
        padding-right: 24px;
      }
    }

    &.scale-navigation-tools-rows {
      flex-basis: 20%;

      @media (min-width: ${breakpoints.hd.width}px) {
        flex-basis: 30%;
      }

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        flex-basis: 30%;
        margin-bottom: 16px;
        padding-right: 0;
      }

      &:not(:last-child) {
        padding-right: 24px;
      }
    }

    &.annotation-tools-rows {
      flex-basis: 55%;

      @media (min-width: ${breakpoints.hd.width}px) {
        flex-basis: 65%;
      }

      @media (min-width: ${breakpoints.wxgaPlus.width}px) {
        flex-basis: 44%;
      }
    }

    &.segmentation-tools-rows {
      width: 100%;

      .tool-label {
        position: relative;

        &:nth-of-type(1) {
          padding-right: 32px;

          &:after {
            background-color: ${colors.softBlue};
            content: '';
            display: block;
            height: 32px;
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
          }
        }

        &:nth-of-type(2) {
          padding-right: 8px;
        }

        &:nth-of-type(3),
        &:nth-of-type(4) {
          padding-right: 16px;
        }
      }

      .diameter-input-wrapper {
        padding-right: 16px;
      }

      .diameter-range-wrapper,
      .density-limits-wrapper {
        padding-right: 32px;
        position: relative;

        &:after {
          background-color: ${colors.softBlue};
          content: '';
          display: block;
          height: 32px;
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
        }
      }

      .select-classification {
        ${fontFamily.sourceSansPro.regular};
        align-items: center;
        background-color: transparent;
        border-radius: 8px;
        color: ${colors.white};
        display: flex;
        flex-wrap: nowrap;
        font-size: 14px;
        height: 48px;
        justify-content: center;
        line-height: 20px;
        padding: 12px;

        &:active {
          background-color: ${colors.mostlyBlack};
    
          &.red-color,
          &.blue-color,
          yellow-color {
            .box {
              border: solid 2px ${colors.softBlue};
            }
          }
        }
    
        &.red-color {
          margin-right: 16px;
    
          .box {
            border: solid 2px ${colors.softRed};
            background-color: ${colors.softRed};
          }
        }
    
        &.blue-color {
          .box {
            border: solid 2px ${colors.softBlue};
            background-color: ${colors.softBlue};
          }
        }
    
        &.yellow-color {
          .box {
            border: solid 2px ${colors.softYellow};
            background-color: ${colors.softYellow};
          }
        }
    
        .box {
          border-radius: 8px;
          display: block;
          height: 20px;
          margin-right: 8px;
          width: 20px;
        }
      }

      .save-button-wrapper {
        margin-left: 16px;
      }
    }

    .select-exam-container {
      flex-basis: 46%;
      margin-right: 24px;
    }

    .select-tool-container {
      align-items: center;
      display: flex;
      flex-basis: 16%;
      margin-right: 24px;

      .tool-label {
        margin-right: 12px;
      }
    }

    .select-slice-container {
      align-items: center;
      display: flex;
      flex-basis: 38%;
      flex-wrap: nowrap;

      .tool-label {
        margin-right: 12px;
      }

      .navigation-slice-wrapper {
        align-items: center;
        display: flex;
        flex-wrap: nowrap;
        width: 100%;

        .single-item-navigation-wrapper {
          flex-basis: 61.85%;
          margin-right: 12px;
        }

        .range-navigation-wrapper {
          flex-basis: 38.5%;
          margin-left: 12px;
        }
      }
    }

    .zoom-tool-container {
      align-items: center;
      display: flex;
      margin-right: 24px;
      width: 100%;

      .tool-label {
        margin-right: 12px;
      }
    }

    .navigation-container {
      display: flex;

      .last-navigation-link,
      .next-navigation-link {
        flex-basis: 50%;
      }

      .last-navigation-link {
        margin-right: 8px;
      }

      .next-navigation-link {
        margin-left: 8px;
      }
    }



    .types-select-container {
      align-items: center;
      display: flex;
      flex-wrap: nowrap;
      width: 100%;

      .tool-label {
        ${fontFamily.sourceSansPro.bold}
        margin-right: 8px;
        padding-right: 8px;
        position: relative;

        @media (min-width: ${breakpoints.hd.width}px) {
          margin-right: 16px;
          padding-right: 16px;
          white-space: nowrap;
        }

        &:after {
          background: ${colors.slightlyDesaturatedBlue};
          content: '';
          display: block;
          height: 32px;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
        }
      }

      .select-list-wrapper {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;

        .select-type-wrapper,
        .select-subtype-wrapper {
          flex-basis: 45%;
          padding-right: 4px;

          @media (min-width: ${breakpoints.hd.width}px) {
            padding-right: 8px;
          }
        }

        .select-subtype-wrapper {
          padding-left: 4px;

          @media (min-width: ${breakpoints.hd.width}px) {
            padding-left: 8px;
          }
        }
      }

      .save-button-wrapper {
        flex-basis: 10%;
        padding-left: 4px;

        @media (min-width: ${breakpoints.hd.width}px) {
          padding-left: 8px;
        }
      }
    }
  }
`;

export const Canvas = styled.canvas`
  background-color: black;
  margin: auto;
`;


export const PreviewsScrollWrapper = styled.div`
  grid-area: previews;
  width: 100%;
  height: 100%;
  ${props => props.isRadiography ? 'overflow-y: auto;' : 'overflow-y: hidden;'}
  overflow-x: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "original editor";
`;


export const OriginalPreviewWrapper = styled.div`
  grid-area: original;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: min-content;
`;

export const OriginalPreview = styled(Canvas)`
  grid-area: originalPreview;
`;

export const EditorPreview = styled(Canvas)`
  position: absolute;
  background-color: transparent;
`;

export const EditorPreviewWrapper = styled.div`
  grid-area: editor;
  position: relative;
  display: flex;
  justify-content: center;
  ${props => props.isRadiography ? '' : 'align-items: center;'}
  min-height: min-content;
`;

export const RangeWrapper = styled.div`
  width: 100%;
  height: 100px;
  background-color: rgb(68, 77, 90);
  padding: 12px 68px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Range = styled.input`
  width: 100%;
  -webkit-appearance: none;

  &::-webkit-slider-runnable-track {
    background-color: #d7dbdd;
    height: 6px;
    border-radius: 3px;
    border: 1px solid transparent;
  }

  &[disabled]::-webkit-slider-runnable-track {
    border: 1px solid #d7dbdd;
    background-color: transparent;
    opacity: 0.4;
  }

  &::-moz-range-track {
    background-color: #d7dbdd;
    height: 6px;
    border-radius: 3px;
    border: none;
  }

  &::-ms-track {
    color: transparent;
    border: none;
    background: none;
    height: 6px;
  }

  &::-ms-fill-lower {
    background-color: #d7dbdd;
    border-radius: 3px;
  }

  &::-ms-fill-upper {
    background-color: #d7dbdd;
    border-radius: 3px;
  }

  &::-ms-tooltip {
    display: none;
  }

  &::-moz-range-thumb {
    border-radius: 20px;
    height: 18px;
    width: 18px;
    border: none;
    background: none;
    background-color: ${colors.softBlue};
  }

  &:active::-moz-range-thumb {
    outline: none;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none !important;
    border-radius: 100%;
    background-color: ${colors.softBlue};
    height: 18px;
    width: 18px;
    margin-top: -7px;
  }

  &[disabled]::-webkit-slider-thumb {
    background-color: transparent;
    border: 1px solid #d7dbdd;
  }

  &:active::-webkit-slider-thumb {
    outline: none;
  }

  &::-ms-thumb {
    border-radius: 100%;
    background-color: ${colors.softBlue};
    height: 18px;
    width: 18px;
    border: none;
  }

  &:active::-ms-thumb {
    border: none;
  }
`;

export const DensityRange = styled.input`
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  background-color: transparent;
  pointer-events: none;

  &::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    height: 6px;
  }

  &::-moz-range-track {
    -webkit-appearance: none;
    height: 6px;
  }

  &::-ms-track {
    -webkit-appearance: none;
    height: 6px;
  }

  &::-ms-fill-lower {
    background-color: ${colors.softBlue}; 
    border-radius: 3px;
  }

  &::-ms-fill-upper {
    background-color: ${colors.softBlue};
    border-radius: 3px;
  }

  &::-ms-tooltip {
    display: none;
  }

  &::-moz-range-thumb {
    border-radius: 20px;
    height: 18px;
    width: 18px;
    border: none;
    background: none;
    background-color: #d7dbdd;
    cursor: pointer;
    pointer-events: auto;
  }

  &:active::-moz-range-thumb {
    outline: none;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none !important;
    border-radius: 100%;
    background-color: #d7dbdd;
    height: 18px;
    width: 18px;
    margin-top: -7px;
    cursor: pointer;
    pointer-events: auto;
  }

  &[disabled]::-webkit-slider-thumb {
    background-color: transparent;
    border: 1px solid #d7dbdd;
  }

  &:active::-webkit-slider-thumb {
    outline: none;
  }

  &::-ms-thumb {
    appearance: none;
    border-radius: 100%;
    background-color: #d7dbdd;
    height: 18px;
    width: 18px;
    border: none;
    cursor: pointer;
    pointer-events: auto;
  }

  &:active::-ms-thumb {
    border: none;
  }

`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
`;

export const Span = styled.span`
  ${fontFamily.sourceSansPro.regular}
  color: ${colors.mostlyWhite};
`;

export const SaveButton = styled.button`
  width: auto;
  border-none: none;
  background-color: ${colors.softBlue};
  padding: 20px 35px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 14px;
  ${fontFamily.sourceSansPro.regular}
  color: ${colors.mostlyWhite};
  transition: 0.5s all ease-in-out;

  :hover {
    background-color: #abc123;
    transition: 0.5s all ease-in-out;
  }
`;